import React from 'react';
import { BitcoinIcon, CoinsIcon, LineChartIcon, RefreshCwIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { TradingViewWidget } from './TradingViewWidget';
const CATEGORIES = [{
  label: 'Forex',
  Icon: RefreshCwIcon
}, {
  label: 'Índices',
  Icon: LineChartIcon
}, {
  label: 'Metales',
  Icon: CoinsIcon
}, {
  label: 'Criptomonedas',
  Icon: BitcoinIcon
}];
const TICKER_CONFIG = {
  symbols: [{
    proName: 'OANDA:XAUUSD',
    title: 'Oro'
  }, {
    proName: 'FX:EURUSD',
    title: 'EUR/USD'
  }, {
    proName: 'FX:GBPJPY',
    title: 'GBP/JPY'
  }, {
    proName: 'OANDA:NAS100USD',
    title: 'US 100'
  }, {
    proName: 'BITSTAMP:BTCUSD',
    title: 'BTC/USD'
  }, {
    proName: 'OANDA:XAGUSD',
    title: 'Plata'
  }],
  colorTheme: 'dark',
  locale: 'es',
  largeChartUrl: '',
  isTransparent: true,
  showSymbolLogo: true,
  displayMode: 'adaptive'
};
export function TrustBar() {
  return <>
      <div className="bg-brand-950" aria-label="Cotizaciones de mercado en vivo" data-id="element-215" data-mp="ajerf3t5bgl3">
        <div className="h-[46px]" data-id="element-216" data-mp="1aindzk8jq3hf">
          <TradingViewWidget kind="ticker-tape" config={TICKER_CONFIG} data-id="element-217" data-mp="1ajotc0wlhc4y" />
        </div>
      </div>

      <section aria-label="Categorías de mercado" className="relative rounded-t-[32px] border-b border-line bg-white" data-id="element-218" data-mp="16in1i550c2d0">
        <Reveal className="mx-auto flex max-w-[1400px] flex-col items-center gap-7 px-5 py-9 lg:flex-row lg:justify-between lg:px-8" data-id="element-219" data-mp="1keqj8yyp2i8l">
          <p className="text-center text-[11px] font-semibold uppercase tracking-overline text-ink-400 lg:text-left" data-id="element-220" data-mp="1tgzrfi6hpzit">
            Una experiencia diseñada para el trader moderno
          </p>
          <ul className="grid w-full grid-cols-2 gap-x-8 gap-y-4 sm:flex sm:w-auto sm:items-center sm:gap-10" data-id="element-221" data-mp="238442b8p18ah">
            {CATEGORIES.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-2.5 text-[13px] font-semibold text-ink-700" data-id="element-222" data-mp="1yau7mbmvzwd5">
                <Icon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-223" data-mp="287qlkwvk1ap3" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </section>
    </>;
}